import * as yup from 'yup';
import docs from './attachments';
import {
  abatimentoDoEmprestimoCondicional,
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenalCondicional,
  boletoEmprestimoObrigatorio,
  consentimentoDescontoFolha,
  cpfResponsavelLegal,
  nomeDoTutor,
  optoPor,
  parcelaAVistaCondicional,
  parentesco,
  retiradaAVistaCondicional,
  aceiteInss,
  consentimentoAcertoFinanceiro,
} from './utils/rulesByKey';

export const saldoMATSchema = (saldoDevedor) => {
  if (saldoDevedor) {
    return yup.object({
      ...parentesco,
      ...cpfResponsavelLegal,
      ...nomeDoTutor,
      ...optoPor,
      ...adiantamentoQuinzenalCondicional,
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...consentimentoDescontoFolha,
      ...consentimentoAcertoFinanceiro,
      ...parcelaAVistaCondicional,
      ...retiradaAVistaCondicional,
      ...boletoEmprestimoObrigatorio,
      ...abatimentoDoEmprestimoCondicional,
      ...docs.SaldoMATDocs.rules,
      ...aceiteInss,
    });
  }

  return yup.object({
    ...parentesco,
    ...cpfResponsavelLegal,
    ...nomeDoTutor,
    ...optoPor,
    ...adiantamentoQuinzenalCondicional,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...consentimentoDescontoFolha,
    ...parcelaAVistaCondicional,
    ...retiradaAVistaCondicional,
    ...docs.SaldoMATDocs.rules,
    ...aceiteInss,
  });
};

export const saldoMATInitialValues = {
  parentesco: '',
  cpfResponsavelLegal: '',
  nomeDoTutor: '',
  adiantamentoQuinzenal: '',
  optoPor: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  consentimentoAcertoFinanceiro: false,
  aceiteInss: false,
  parcelaAVista: '',
  retiradaAVista: '',
  boletoEmprestimo: '',
  abatimentoDoEmprestimo: '',
  ...docs.SaldoMATDocs.initialValues,
};

export const saldoMATDocs = {
  ...docs.SaldoMATDocs.docs,
};
